import React, { useEffect, useState } from "react";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";

const OrgFeatureItemDetail = (props) => {
  const {item, setIsVisible} = props;
  const mrIntl = useTranslate();
  
  return (
    <div className="org-feature-item-detail">
      {props.renderForm({
        name: "features",
        config: {
          isModal: false,
          visible: true,
          actions: {
            submitText: mrIntl("CommonText.save"),
          },
          submitConfig: {
            hideForm: true,
            successCallback: (data) => {
              if (data.status === 200) {
                console.log("success 12 => ", data);
                setIsVisible(false);
                window.location.reload();
              }
            },
            errorCallback: (error) => {
              console.log("error 12 => ", error);
            }
          },
        },
        resource: item, //use this for edit
      })}
    </div>
  );
}

export default OrgFeatureItemDetail;
